// extracted by mini-css-extract-plugin
module.exports = {"benefitsHeadline":"my-newsletter-benefits_benefitsHeadline__wEgcS","benefitsWrap":"my-newsletter-benefits_benefitsWrap__LCw0k","benefit":"my-newsletter-benefits_benefit__0HbU5"};